import * as S from './styles.ts';
import { Button, H3, P } from '@template/components';
import Check from '@template/icons/Check.tsx';
import X from '@template/icons/X.tsx';
import Image, { ImageProps } from '@template/components/Image';
import { IButtonProps } from '@template/components/Button';

type ValueType = string | boolean;

export type ComparisonSectionProps = {
  title?: string;
  description?: string;
  comparisonHeaders: ({ title: string } | ImageProps)[];
  comparisons: [
    {
      title: string;
      values: { value: ValueType }[];
    },
  ];
  cta: IButtonProps;
};

export const ComparisonSection = ({
  title,
  description,
  comparisonHeaders,
  comparisons,
  cta,
}: ComparisonSectionProps) => {
  const handleValue = (value: ValueType) => {
    switch (value) {
      case false:
        return <X width={36} height={36} />;
      case true:
        return <Check width={36} height={36} />;
      default:
        return value;
    }
  };
  return (
    <S.Wrapper>
      <S.Container>
        {title && <H3>{title}</H3>}
        {description && <P>{description}</P>}
        <S.ComparisonTable>
          <thead>
            <tr>
              <th />
              {comparisonHeaders.map((header, index) => (
                <th key={index}>
                  {header?.title ? (
                    header.title
                  ) : (
                    <Image height={40} {...(header as any)} key='abc' />
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {comparisons.map((comparison, index) => (
              <tr key={index}>
                <td>{comparison.title}</td>
                {comparison?.values?.map(({ value }, index) => (
                  <td
                    key={index}
                    data-type={
                      value === false
                        ? 'false'
                        : value === true
                          ? 'true'
                          : undefined
                    }
                  >
                    {handleValue(value)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </S.ComparisonTable>
        {cta && <Button {...cta} style={{ width: 'fit-content' }} />}
      </S.Container>
    </S.Wrapper>
  );
};
